export default __webpack_public_path__ + "static/media/Radio_Nacional_Logo_2021.18bd9474.jpg";